import { InjectionToken, inject, type Provider } from '@angular/core';
import { UserProfileService } from '../../core/user-profile.service';
import { RoleAuthorizationService } from '../../core/role-authorization.service';
import type { AssistantContext } from './assistant.models';

/** Read fresh context per question; never persist user details in browser storage. */
export const ASSISTANT_CONTEXT = new InjectionToken<() => AssistantContext>('Assistant context', {
  providedIn: 'root',
  factory: () => () => ({ partnerId: null, roles: [] }),
});

export const ASSISTANT_CONTEXT_PROVIDER: Provider = {
  provide: ASSISTANT_CONTEXT,
  useFactory: () => {
    const profiles = inject(UserProfileService);
    const authorization = inject(RoleAuthorizationService);
    return (): AssistantContext => {
      const partner = profiles.selectedPartnerId().trim();
      // Follow the portal's IDM-backed organization selection; never substitute an identity.
      return {
        partnerId: partner || null,
        roles: authorization.getRoles(),
      };
    };
  },
};

/** Stable comparison only; context is never proof of authorization. */
export function assistantContextKey(context: AssistantContext): string {
  return JSON.stringify([context.partnerId, [...context.roles].sort()]);
}
